import styled from "styled-components";
import { List, ListItem, ListItemText, Box } from "@mui/material";

export const StyledItemText = styled(ListItemText)`
   p {
    color: ${({ theme }) => theme.COLORS.WHITE};
    font-size: 1.4rem;
    font-family: 'Mont-Medium';
   }

   .link {
    color: ${({ theme }) => theme.COLORS.YELLOW};
   }

   p:hover {
    color: ${({ theme }) => theme.COLORS.YELLOW};
   }
`;



export const StyledListItem = styled(ListItem)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 2rem !important;    
`;

export const StyledList = styled(List)`
  padding: 2rem 2.6rem !important;
  background-color:  ${({ theme }) => theme.COLORS.LIGHTBLUE2} !important;
  height: 100%;

  .redes-sociais {
    text-align: center;
  }

`;

export const HeaderContainer = styled(Box)`
  .header {
    background: ${({ theme }) => theme.COLORS.BACKGROUND_BLUE};

   
    .active-link {
      color: ${({ theme }) => theme.COLORS.YELLOW};

      &::after {
        transform: scaleX(1);
      }
    }
  }

  .nav-container {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    padding: 2rem 1rem;
  }

  .redes-sociais {
    right: 1rem;
    position: absolute;

    img {
      width: 3rem;
    }
  }

  .nav-items { 
    right: 16rem;
    margin-right: 0rem;
    display: flex;
    align-items: center;
    position: absolute;

    > ul {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: clamp(1rem, 1.6vw, 3rem);
     
      > li {
        font-size: 2.4rem;
        font-family: 'Mont-Medium';

        .link {
          color: ${({ theme }) => theme.COLORS.YELLOW};
          padding-bottom: 2.8rem;
          position: relative;
        }

        .link:hover {
          color: ${({ theme }) => theme.COLORS.WHITE};
        }

        > a {
          color: ${({ theme }) => theme.COLORS.WHITE};
          padding-bottom: 4.2rem;
          position: relative;

         
        }

        > a:hover {
          color: ${({ theme }) => theme.COLORS.YELLOW};
        }

        > a::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 8px;
          background-color: ${({ theme }) => theme.COLORS.YELLOW};
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.3s ease-in-out;
        }

        > a:hover::after {
          transform: scaleX(1);
        }
      } 
    }
  }

 


#jumping-logo {
    width: 17rem;
    animation: jump 1.5s ease-in-out 0s 3 forwards;
  }
  

  @keyframes jump {
    0%, 100% {
      transform: translateY(0); 
    }
    50% {
      transform: translateY(-13px); 
    }
  }


  @media (max-width: 1400px) {
    .nav-container {
    padding: 1.6rem 1rem;
  }

  .redes-sociais {
    right: 1rem;
    position: absolute;

    img {
      width: 2.5rem;
    }
  }

    .nav-items {
     ul > li {
       font-size: 2rem;

      .link {
        padding-bottom: 2.9rem;
      }

      a {
        padding-bottom: 4.1rem;
      }
     }
    }
  }


  @media (max-width: 1100px) {
    .nav-items {
      right: 15rem;

      ul > li {
        font-size: 1.5rem;

      .link {
        padding-bottom: 3.4rem;
      }

      a {
        padding-bottom: 4.3rem;
      }
     }
    }

  }


  @media (max-width: 900px) {
    .nav-items, .redes-sociais {
      display: none;
    }
  }

`;


export const OutsideLink = styled.a`
 text-decoration: none !important;
`;





